module.exports = __webpack_public_path__ + "img/icon__cycle-black.13640527.svg";